import React from 'react';
import { QuickStatus } from 'components';

export const Home = () => {
	return (
		<QuickStatus />
	);
};